/*
 * It allows looping through arrays and nodes in all browsers
 * i.e. forEach(array, (arrayElement, index) => {})
 */
export const forEach = (array, callback) => {
  if (!array || !callback) return;
  for (var i = 0; i < array.length; i++) {
    callback(array[i], i);
  }
};

/*
 * Finds the first ancestor of the element that matches a specific cssSelector
 * i.e. findAncestor(document.querySelector('div'), '.divs-parent')
 */
export const findAncestor = (el, cssSelector) => {
  while (
    (el = el.parentElement) &&
    !(el.matches || el.matchesSelector).call(el, cssSelector)
  );
  return el;
};

/*
 * Finds the first ancestor of the element that matches a specific computedStyle
 * i.e. findAncestorWithStyle(document.querySelector('div'), 'display', 'block')
 */
export const findAncestorWithStyle = (el, cssProp, cssPropValue) => {
  if (!el || !cssProp || !cssPropValue) return null;
  while (
    (el = el.parentElement) &&
    !(getComputedStyle(el)[cssProp] === cssPropValue)
  );
  return el;
};

/*
 * It inserts a newElement after the specified target
 * i.e. insertAfter(document.querySelector('.insert-after-this'), document.createElement('div'))
 */
export const insertAfter = (target, newElement) => {
  target.parentNode.insertBefore(newElement, target.nextSibling);
};

/*
 * It returns an object with all the query params in any url, defaults to current url
 * i.e. queryParams('https://google.com/?key=value&key2=false&key3=3')
 * expected: {
 key: 'value',
 key2: false,
 key3: 3
}
*/
export const queryParams = (url = location.search) => {
  const i = url.indexOf('?') >= 0 ? url.indexOf('?') : url.length;

  return url
    .substring(i)
    .slice(1)
    .split('&')
    .map(p => p.split('='))
    .reduce((obj, pair) => {
      let [key, value] = pair.map(decodeURIComponent);
      if (!key) return { ...obj };

      if (value === 'true' || !value) {
        value = true;
      } else if (value === 'false') {
        value = false;
      } else if (Number(value)) {
        value = Number(value);
      }

      return { ...obj, [key]: value };
    }, {});
};

/*
 * Returns a string of query params from an object already formatted and encoded.
 * i.e. buildQueryParams({ search: 'stuff', limit: 1 })
 * returns '?search=stuff&limit=1'
 * Pro tip: use it in conjuction with queryParams() to merge the existing params
 buildQueryParams(
   Object.assign({},
     queryParams(),
     { search: 'stuff', limit: 1 }
   )
 )
*/

export const buildQueryParams = object => {
  let params = [];

  try {
    for (let key in object) {
      if (object.hasOwnProperty(key)) {
        params.push(encodeURI(key) + '=' + encodeURI(object[key]));
      }
    }
    return '?' + params.join('&');
  } catch (e) {
    return '';
  }
};

/*
 * Strips the HTML from a string. Works only in the browser.
 * i.e. stripHTML('<p>I am your <strong>father</strong>!</p>')
 * returns 'I am your father!'
 */

export const stripHTML = string => {
  if (document && document.createElement) {
    const el = document.createElement('div');
    el.innerHTML = string;
    string = el.innerText;
  }
  return string;
};

/*
 * Sets a cookie with given name, value and expiration in days
 * i.e. setCookie('cookie', 'monster', 365)
 */
export const setCookie = (cookieName, cookieValue, expirationDays) => {
  const now = new Date();
  now.setTime(now.getTime() + expirationDays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + now.toUTCString();
  document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
};

export const getCookie = name => {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length === 2) {
    return parts
      .pop()
      .split(';')
      .shift();
  }
};

/*
 * It returns a deep clone of the object or null
 * i.e. object = {a: 'a'}
 * object.b = deepClone(object)
 * expected object = {
 a: 'a',
 b: {
 a: 'a'
}
}
*/
export const deepClone = object => {
  let clone = null;

  if (Notification && location.protocol.indexOf('https') >= 0) {
    clone = new Notification('', { data: object, silent: true }).data;
  } else if (history && history.replaceState) {
    const oldState = history.state;
    history.replaceState(object, document.title);
    clone = history.state;
    history.replaceState(oldState, document.title);
  } else {
    try {
      clone = JSON.parse(JSON.stringify(object));
    } catch (e) {
      clone = null;
    }
  }
  // Taken from https://github.com/whatwg/html/issues/793, it's async, me no likey
  // let promise = new Promise(resolve => {
  //   const { port1, port2 } = new MessageChannel()
  //   port2.onmessage = (ev) => {
  //     resolve(ev.data)
  //   }
  //   port1.postMessage(object)
  // })
  // clone = await promise
  return clone;
};

export const toArray = nodes => {
  try {
    return [].slice.call(nodes);
  } catch (e) {
    return [];
  }
};

export const findTallest = elementsOrSelector => {
  let tallest = null;
  const isElements = NodeList.prototype.isPrototypeOf(elementsOrSelector);
  let elements = isElements
    ? elementsOrSelector
    : document.querySelectorAll(elementsOrSelector);
  elements = toArray(elements);

  if (!elements || !elements.length) return tallest;

  tallest = Math.max.apply(Math, elements.map(el => el.offsetHeight));

  tallest = elements.filter(el => el.offsetHeight === tallest)[0];

  return tallest;
};

export default {
  forEach,
  findAncestor,
  insertAfter,
  toArray,
  findTallest,
  queryParams,
  buildQueryParams,
  stripHTML,
  setCookie,
  getCookie,
  deepClone
};



// WEBPACK FOOTER //
// ./src/assets/js/helpers.js